<template>
  <div class="info-preview" mg-stat-show="flag=610" mg-stat-lob="smod=cash_score">
    <!-- 现金板块 -->
    <div class="change-area" v-if="!isNoneCashVer">
      <div class="top-area">
        <div class="amount-info">
          <span class="num">{{ formatMoney(cashUserInfo.cashOutAmount, 2) || 0.00 }}</span>
          <span class="txt">现金</span>
        </div>
        <div class="see-details" @click="viewCashDetails">查看明细</div>
      </div>

      <div class="direct-to" @click="goWithdraw">
        <span class="txt">去提现</span>
        <span class="icon"></span>
      </div>
    </div>
    <!-- 积分板块 -->
    <div class="points-area" :class="isNoneCashVer ? 'special' : ''">
      <div class="top-area">
        <div class="amount-info">
          <span class="num">{{ formatCredits(cashUserInfo.creditsAmount) }}</span>
          <span class="txt">积分</span>
        </div>
        <div class="see-details" @click="viewPointsDetails">查看明细</div>
      </div>

      <div class="direct-to" @click="goExchange" v-if="!isNoneCashVer">
        <span class="txt">去兑换</span>
        <span class="icon"></span>
      </div>
      <div class="direct-to-special" @click="goExchange" v-else>
        <span class="txt">立刻去兑换</span>
        <span class="icon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { jumpPage, } from '@/utils/mUtil';

export default {
  computed: {
    ...mapState(['cashUserInfo', 'isNoneCashVer']),
  },
  created() {
    this.getInfo();
  },
  methods: {
    // 分转元
    formatMoney(num = 0, n = 1) {
      if (num == 0) return 0;
      const yuan = num / 100;
      if (yuan >= 1000) {
        return (yuan / 1000).toFixed(n) + 'k';
      }
      return yuan.toFixed(n);
    },
    // 积分显示（≥ 6 位数显示为 k，保留两位小数）
    formatCredits(num = 0) {
      const val = Number(num) || 0;
      if (val >= 100000) {
        return (val / 1000).toFixed(2) + 'k';
      }
      return val;
    },
    getInfo() {
      this.$store.dispatch('queryCashUserInfo');
    },
    viewCashDetails() {
      const wrappedHandler = this.$wrapClick(() => {
        // 查看现金明细
        this.$router.push('/detail?saasId=13');
      });
      wrappedHandler();
    },
    viewPointsDetails() {
      const wrappedHandler = this.$wrapClick(() => {
        // 查看积分明细
        this.$router.push('/detail?saasId=0');
      });
      wrappedHandler();
    },
    goWithdraw() {
      this.clickReport({
        mod: 'withdraw_money',
        cont: '点击去提现按钮',
      });
      const wrappedHandler = this.$wrapClick(() => {
        // 去提现
        this.$router.push('/cash');
      });
      wrappedHandler();
    },
    clickReport({ mod, cont }) {
      try {
        MgStat.send(
          'click',
          {
          },
          {
            cntp: 'score_newHome',
            mod,
            cont,
          }
        )
      } catch (error) {
        console.error('score_newHome 点击事件 上报失败' + mod + cont);
      }
    },
    goExchange() {
      this.clickReport({
        mod: 'exchange',
        cont: '点击去兑换按钮',
      });

      const wrappedHandler = this.$wrapClick(() => {
        // 去兑换
        jumpPage('https://app.mgtv.com/credits/mall.html?lastp=credits&isV2=1');
      });
      wrappedHandler();
    }
  }
}
</script>

<style scoped lang="less">
  @import './index.less';
</style>
